baseApp.directive('innerLoader', function(){
    return {
        templateUrl: '/public/directives/innerLoader.html',
        replace: true,
        transclude: true,
        scope:{
            show: "=",
            separate: "@"
        },
        link: function ($scope, el) {
            if($scope.separate){
                var $elementJQ = $(el[0]);
                $elementJQ.height($elementJQ.parent().height());
            }
        }
    }
});